import {
  Col,
  Row,
  Table,
  Input,
  Button,
  Select,
  InputNumber,
  AutoComplete,
  Modal,
} from '@oscar/theme';
import { InputText, TextField } from 'common/components';
import { useFormContext, ActionField, Field } from '@oscar/form';
import useStatus from 'views/pages/create-instrulation/hooks/useStatus';
import { DownOutlined } from '@ant-design/icons';
import { useAuth } from 'features/auth';
import { numberWithCommas } from 'features/insulation/utils';
import { set } from 'lodash';
import { useEffect, useState } from 'react';
import { useNonnullFunction } from './ModalContext';
import { useShowfunction } from './ShowContext';
const { Option } = Select;
export const ProposalResult = (props: any) => {
  const { show, setShow } = useShowfunction();

  const { isVisible, setisVisible } = useNonnullFunction();
  const [statusRequest] = useStatus();
  const [auth] = useAuth();
  const { item, readOnly, field, removeItem } = props;
  const [formContext] = useFormContext();
  console.log(item, 'item from item');

  useEffect(() => {
    formContext.form?.setFieldsValue({
      item,
    });
    setShow(item?.worklistID);
  }, [item]);

  const metaDataProposalDetail =
    formContext.selectors?.getDataByKey('metaDataProposalDetail') || {};
  const getPaintingWorkDetail =
    formContext.selectors?.getDataByKey('getPaintingWorkDetail') || {};
  const { submitQAQCsTime } = formContext.selectors?.getInitalValue() || {};

  const modeViewProposalInsulation = () => {
    const proposalBillingDetail = formContext.form?.getFieldValue([
      'proposalBillingDetail',
      'data',
    ]);
    const filteredData = proposalBillingDetail.filter(
      (newitem: any) =>
        newitem?.id === item?.worklistID && newitem?.isProposalList,
    );
    console.log(show, 'show');
    console.log(filteredData, item, 'filter and item');
    return (
      <>
        <Row gutter={12}>
          <Col span={24}>
            <div className="border-bottom-header">
              <TextField
                label="Type of Insulation Work"
                value={item?.insulationWorkOtherDescription}
              />
              {statusRequest?.state === 'EDIT' &&
                statusRequest?.status === 'PENDING_PROPOSAL' &&
                auth.getUserRoles().includes('CONTRACTOR') && (
                  <Button
                    type="primary"
                    className="update-button"
                    onClick={() => {
                      removeItem?.(field);
                    }}
                    size="small"
                  >
                    Remove from list
                  </Button>
                )}
              {statusRequest?.state === 'EDIT' &&
                statusRequest?.status === 'BILLING' &&
                auth.getUserRoles().includes('INSULATION') &&
                (!!show ? (
                  <Button
                    type="primary"
                    className="update-button"
                    onClick={() => setisVisible(prev => !prev)}
                    size="small"
                  >
                    Original Proposal
                  </Button>
                ) : (
                  <span>Details added after pending proposal</span>
                ))}
            </div>
          </Col>
          <Modal
            title="Original Proposal"
            visible={isVisible}
            onOk={() => {
              setisVisible(prev => !prev);
            }}
          >
            <Row>
              <Col>
                <TextField
                  label="Type of Insulation Work"
                  value={filteredData?.[0]?.insulationWorkOtherDescription}
                />
              </Col>
            </Row>
            <Row gutter={12}>
              <Col span={8}>
                <TextField
                  label="Work Item"
                  value={filteredData?.[0]?.workItemOtherDescription}
                />
              </Col>
              <Col span={8}>
                <TextField
                  label="Metal Cladding"
                  value={filteredData?.[0]?.metalCladdingOtherDescription}
                />
              </Col>
              <Col span={8}>
                <TextField
                  label="Insulation Material"
                  value={filteredData?.[0]?.materialOtherDescription}
                />
              </Col>
            </Row>
            <Row gutter={12}>
              <Col span={8}>
                <TextField
                  label="Size"
                  value={filteredData?.[0]?.sizeOtherDescription}
                />
              </Col>
              <Col span={8}>
                <TextField
                  label="Thickness"
                  value={filteredData?.[0]?.thicknessOtherDescription}
                />
              </Col>
              <Col span={8}>
                <TextField
                  label="PO Number"
                  value={filteredData?.[0]?.poNumber}
                />
              </Col>
            </Row>
            <Row gutter={12}>
              <Col span={8}>
                {filteredData?.[0]?.poNumber1 && (
                  <TextField
                    label="PO Number 2"
                    value={filteredData?.[0]?.poNumber1}
                  />
                )}
              </Col>
              <Col span={8}>
                {filteredData?.[0]?.poNumber2 && (
                  <TextField
                    label="PO Number 3"
                    value={filteredData?.[0]?.poNumber2}
                  />
                )}
              </Col>
              <Col span={8}>
                {filteredData?.[0]?.poNumber3 && (
                  <TextField
                    label="PO Number 4"
                    value={filteredData?.[0]?.poNumber3}
                  />
                )}
              </Col>
            </Row>
            <Row gutter={12}>
              <Col span={8}>
                <TextField
                  label="Measurement"
                  value={numberWithCommas(filteredData?.[0]?.measurement)}
                />
              </Col>
              <Col span={8}>
                <TextField
                  label="Unit"
                  value={filteredData?.[0]?.unitOtherDescription}
                />
              </Col>
              <Col span={8}>
                <TextField
                  label="Quoted Cost (RM)"
                  value={numberWithCommas(filteredData?.[0]?.quotedCost)}
                />
              </Col>
            </Row>
            {/* <Row gutter={12}>
              <Col span={8}>
                <TextField
                  label="Final Measurement"
                  value={filteredData?.[0]?.finalMeasurement}
                />
              </Col>
              <Col span={8}>
                {statusRequest?.type === 'PAINTING' ? (
                  <TextField
                    label="UOM"
                    value={item?.uom}
                    mappingData={getPaintingWorkDetail?.uom}
                  />
                ) : (
                  <TextField
                    label="Unit"
                    value={filteredData?.[0]?.unitOtherDescription}
                  />
                )}
              </Col>
              <Col span={8}>
                <TextField
                  label="Final Cost"
                  value={filteredData?.[0]?.finalCost}
                />
              </Col>
            </Row> */}
          </Modal>
        </Row>
        <Row gutter={12}>
          <Col span={8}>
            <TextField
              label="Work Item"
              value={item?.workItemOtherDescription}
            />
          </Col>
          <Col span={8}>
            <TextField
              label="Metal Cladding"
              value={item?.metalCladdingOtherDescription}
            />
          </Col>
          <Col span={8}>
            <TextField
              label="Insulation Material"
              value={item?.materialOtherDescription}
            />
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={8}>
            <TextField label="Size" value={item?.sizeOtherDescription} />
          </Col>
          <Col span={8}>
            <TextField
              label="Thickness"
              value={item?.thicknessOtherDescription}
            />
          </Col>
          <Col span={8}>
            <TextField label="PO Number" value={item?.poNumber} />
          </Col>
        </Row>
        <Row gutter={12}>
          {item?.poNumber1 && (
            <Col span={8}>
              <TextField label="PO Number 2" value={item?.poNumber1} />
            </Col>
          )}
          {item?.poNumber2 && (
            <Col span={8}>
              <TextField label="PO Number 3" value={item?.poNumber2} />
            </Col>
          )}
          {item?.poNumber3 && (
            <Col span={8}>
              <TextField label="PO Number 4" value={item?.poNumber3} />
            </Col>
          )}
        </Row>
        <Row gutter={12}>
          <Col span={8}>
            <TextField
              label="Measurement"
              value={numberWithCommas(item?.measurement)}
            />
          </Col>
          <Col span={8}>
            <TextField label="Unit" value={item?.unitOtherDescription} />
          </Col>
          <Col span={8}>
            <TextField
              label="Quoted Cost (RM)"
              value={numberWithCommas(item?.quotedCost)}
            />
          </Col>
        </Row>
      </>
    );
  };

  const modeViewProposalAddtional = (type: any) => {
    return (
      <Row gutter={12}>
        <Col span={8}>
          {/* <p>Final Measurement</p>
          <Field
            {...field}
            name={[field!.name, 'finalMeasurement']}
            fieldKey={[field!.fieldKey, 'finalMeasurement']}
          >
            <InputNumber
              placeholder="Final Measurement"
              min="0"
              decimalSeparator="."
              precision={2}
            />
          </Field> */}
          <TextField label="Final Measurement" value={item?.finalMeasurement} />
        </Col>
        <Col span={8}>
          {type === 'PAINTING' ? (
            <TextField
              label="UOM"
              value={item?.uom}
              mappingData={getPaintingWorkDetail?.uom}
            />
          ) : (
            <TextField label="Unit" value={item?.unitOtherDescription} />
          )}
        </Col>
        <Col span={8}>
          {/* <p>Final Cost (RM)</p>
          <Field
            {...field}
            name={[field!.key, 'finalCost']}
            fieldKey={[field!.fieldKey, 'finalCost']}
          >
            {/* <InputNumber
              placeholder="Final Cost"
              min="0"
              decimalSeparator="."
              precision={2}
            /> 
          </Field> */}
          <TextField label="Final Cost" value={item?.finalCost} />
        </Col>
      </Row>
    );
  };

  const modeViewProposalPainting = () => {
    const proposalBillingDetail = formContext.form?.getFieldValue([
      'proposalBillingDetail',
      'data',
    ]);
    const filteredData = proposalBillingDetail.filter(
      (newitem: any) => newitem?.id === item?.worklistID,
    );
    return (
      <>
        <Row gutter={12}>
          <Col span={24}>
            <div className="border-bottom-header">
              <TextField
                label="Item Description"
                value={item?.itemDescription}
                mappingData={metaDataProposalDetail?.itemDescription}
              />
              {statusRequest?.state === 'EDIT' &&
                statusRequest?.status === 'PENDING_PROPOSAL' &&
                auth.getUserRoles().includes('CONTRACTOR') && (
                  <Button
                    type="primary"
                    className="update-button"
                    onClick={() => {
                      removeItem?.(field);
                    }}
                    size="small"
                  >
                    Remove from list
                  </Button>
                )}
              {statusRequest?.state === 'EDIT' &&
                statusRequest?.status === 'BILLING' &&
                auth.getUserRoles().includes('PAINTING') &&
                (!!show ? (
                  <Button
                    type="primary"
                    className="update-button"
                    onClick={() => setisVisible(prev => !prev)}
                    size="small"
                  >
                    Original Proposal
                  </Button>
                ) : (
                  <span>Details added after pending proposal</span>
                ))}
              <Modal
                title="Original Proposal"
                visible={isVisible}
                onOk={() => {
                  setisVisible(prev => !prev);
                }}
              >
                <Row>
                  <Col>
                    <TextField
                      label="Type of Insulation Work"
                      value={filteredData?.[0]?.itemDescription}
                    />
                  </Col>
                </Row>
                <Row gutter={12}>
                  <Col span={12}>
                    <TextField
                      label="Estimated Measurement"
                      value={numberWithCommas(
                        filteredData?.[0]?.estimatedMeasurement,
                      )}
                    />
                  </Col>
                  <Col span={12}>
                    <TextField
                      label="UOM"
                      value={filteredData?.[0]?.uom}
                      mappingData={getPaintingWorkDetail?.uom}
                    />
                  </Col>
                </Row>
                <Row gutter={12}>
                  <Col span={12}>
                    <TextField
                      label="Quoted Cost (RM)"
                      value={numberWithCommas(filteredData?.[0]?.quotedCost)}
                    />
                  </Col>
                  <Col span={12}>
                    <TextField
                      label="PO Number 1"
                      value={filteredData?.[0]?.poNumber}
                    />
                  </Col>
                </Row>
                <Row gutter={12}>
                  <Col span={8}>
                    {filteredData?.[0]?.poNumber1 && (
                      <TextField
                        label="PO Number 2"
                        value={filteredData?.[0]?.poNumber1}
                      />
                    )}
                  </Col>
                  <Col span={8}>
                    {filteredData?.[0]?.poNumber2 && (
                      <TextField
                        label="PO Number 3"
                        value={filteredData?.[0]?.poNumber2}
                      />
                    )}
                  </Col>
                  <Col span={8}>
                    {filteredData?.[0]?.poNumber3 && (
                      <TextField
                        label="PO Number 4"
                        value={filteredData?.[0]?.poNumber3}
                      />
                    )}
                  </Col>
                </Row>
                <Row gutter={12}>
                  <Col span={8}>
                    <TextField
                      label="Final Measurement"
                      value={numberWithCommas(
                        filteredData?.[0]?.finalMeasurement,
                      )}
                    />
                  </Col>
                  <Col span={8}>
                    <TextField
                      label="UOM"
                      value={filteredData?.[0]?.uom}
                      mappingData={getPaintingWorkDetail?.uom}
                    />
                  </Col>
                  <Col span={8}>
                    <TextField
                      label="Final Cost (RM)"
                      value={numberWithCommas(filteredData?.[0]?.finalCost)}
                    />
                  </Col>
                </Row>
              </Modal>
            </div>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={12}>
            <TextField
              label="Estimated Measurement"
              value={numberWithCommas(item?.estimatedMeasurement)}
            />
          </Col>
          <Col span={12}>
            <TextField
              label="UOM"
              value={item?.uom}
              mappingData={getPaintingWorkDetail?.uom}
            />
          </Col>
          <Col span={12}>
            <TextField
              label="Quoted Cost (RM)"
              value={numberWithCommas(item?.quotedCost)}
            />
          </Col>
          <Col span={12}>
            <TextField label="PO Number 1" value={item?.poNumber} />
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={8}>
            {' '}
            {item?.poNumber1 && (
              <TextField label="PO Number 2" value={item?.poNumber1} />
            )}
          </Col>
          <Col span={8}>
            {' '}
            {item?.poNumber2 && (
              <TextField label="PO Number 3" value={item?.poNumber2} />
            )}
          </Col>
          <Col span={8}>
            {' '}
            {item?.poNumber3 && (
              <TextField label="PO Number 4" value={item?.poNumber3} />
            )}
          </Col>
        </Row>
      </>
    );
  };

  const checkPaintingFinal = (statusRequestParam: any) => {
    return (
      statusRequestParam?.status?.includes?.('PENDING_PAINTING') &&
      statusRequestParam?.state === 'EDIT' &&
      auth.getUserRoles().includes('CONTRACTOR') &&
      submitQAQCsTime?.submittedTime ===
        submitQAQCsTime?.needToSubmittedTime - 1
    );
  };
  const checkPaintingQAQCFinal = (statusRequestParam: any) => {
    return (
      statusRequestParam?.status?.includes?.('PENDING_QAQC') &&
      submitQAQCsTime?.submittedTime ===
        submitQAQCsTime?.needToSubmittedTime - 1
    );
  };

  return (
    <div className="notification-detail">
      <div className="notification-detail-content">
        {item && field ? (
          <div>
            {statusRequest?.type !== 'PAINTING' && (
              <>
                {statusRequest?.status === 'PENDING_PROPOSAL' &&
                  modeViewProposalInsulation()}

                {statusRequest?.status === 'PENDING_REINSTATEMENT' && (
                  <>
                    {statusRequest?.state === 'EDIT' &&
                    auth.getUserRoles().includes('CONTRACTOR') ? (
                      <>
                        {modeViewProposalInsulation()}
                        {modeViewProposalAddtional(statusRequest?.type)}
                      </>
                    ) : (
                      modeViewProposalInsulation()
                    )}
                  </>
                )}
              </>
            )}

            {statusRequest?.type === 'PAINTING' && (
              <>
                {statusRequest?.status === 'PENDING_PROPOSAL' &&
                  modeViewProposalPainting()}

                {checkPaintingFinal(statusRequest) ? (
                  <>
                    {modeViewProposalPainting()}
                    {modeViewProposalAddtional(statusRequest?.type)}
                  </>
                ) : (
                  (statusRequest?.status?.includes('PENDING_PAINTING') ||
                    (statusRequest?.status?.includes('PENDING_QAQC') &&
                      !checkPaintingQAQCFinal(statusRequest))) &&
                  modeViewProposalPainting()
                )}
              </>
            )}

            {((statusRequest?.status &&
              ['PENDING_REMOVAL', 'IN_SERVICE', 'BILLING', 'CLOSED'].includes(
                statusRequest?.status,
              )) ||
              (statusRequest?.status === 'PENDING_QAQC' &&
                statusRequest?.type !== 'PAINTING') ||
              checkPaintingQAQCFinal(statusRequest)) && (
              <>
                {statusRequest?.type === 'PAINTING'
                  ? modeViewProposalPainting()
                  : modeViewProposalInsulation()}

                <Row gutter={12}>
                  <Col span={8}>
                    <TextField
                      label="Final Measurement"
                      value={numberWithCommas(item?.finalMeasurement)}
                    />
                  </Col>
                  {statusRequest?.type === 'PAINTING' ? (
                    <Col span={8}>
                      <TextField
                        label="UOM"
                        value={item?.uom}
                        mappingData={getPaintingWorkDetail?.uom}
                      />
                    </Col>
                  ) : (
                    <Col span={8}>
                      <TextField
                        label="Unit"
                        value={item?.unitOtherDescription}
                      />
                    </Col>
                  )}

                  <Col span={8}>
                    <TextField
                      label="Final Cost (RM)"
                      value={numberWithCommas(item?.finalCost)}
                    />
                  </Col>
                </Row>
              </>
            )}
          </div>
        ) : (
          <div>
            Add notification from the search result to the list or click Create
            New to create a new one
          </div>
        )}
      </div>
    </div>
  );
};
